<ion-grid [fixed]="true" class="ion-justify-content-center ion-align-items-center">
  <ion-row>
    <ion-col class="ion-text-center" size="4" offset="4">
      <ion-img id="logo" src="assets/img/LOGO_HORIZONTAL.png" alt="logo-image" class="login-padding-top" />
    </ion-col>
  </ion-row>
</ion-grid>